import { padNum } from "./number";

export const zeroDate = "0001-01-01T00:00:00Z";
// Since getYearData is used in constants/index.ts, we need to declare it here.
// It creates a circular dependency if we try to import it from constants/index.ts.
// Maybe we should move date constats to here?
const currentYear = new Date().getFullYear();

export const mapZeroDate = (date?: string) =>
  date === zeroDate || !date ? undefined : date;

export const createIsoDate = (
  year: number,
  month: number,
  day: number = 1,
): string => {
  return `${year}-${padNum(month)}-${padNum(day)}T00:00:00-05:00`;
};

export const parseIsoDate = (isoDate: string) => {
  const dateString = isoDate.split("T")[0];
  const dateParts = dateString.split("-");
  return {
    year: dateParts[0],
    month: dateParts[1],
    day: dateParts[2],
  };
};

export const getYearData = (start_year?: number, end_year?: number) => {
  const start = start_year ?? currentYear;
  const end = end_year ?? currentYear - 120;
  const ascending = start < end;
  const arrayLength = Math.abs(end - start) + 1;

  return Array.from({ length: arrayLength }, (_, i) =>
    ascending ? start + i : start - i,
  ).map((val) => ({
    id: String(val),
    label: String(val),
  }));
};
